import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/geologica";
import "@fontsource-variable/golos-text";
import "@fontsource-variable/jetbrains-mono";
import "@fontsource-variable/playfair-display/wght-italic.css";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
